// extracted by mini-css-extract-plugin
export default {"containerListTable":"StockContainersTable_containerListTable__ZVWuO"};